import ApiService from "@/common/api/api.service";

const EmpresasService = {
  listar(porPagina = 0, pagina = 0) {
    return ApiService.get(`Empresa?TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  buscarPorId(id) {
    return ApiService.get(`Empresa/${id}`);
  },
  salvar(form) {
    let result = [];
    if (!form.id) result = ApiService.post(`Empresa`, { ...form });
    else result = ApiService.put(`Empresa`, { ...form });
    return result;
  },
  excluir(id) {
    return ApiService.delete(`Empresa?id=${id}`);
  },

  buscarTipo(tipo) {
    return ApiService.get(`Empresa/tipo/?tipo=${tipo}`);
  },

  listarDropdown(){
    return ApiService.get(`Empresa/dropdown`)
  }
};

export default EmpresasService;
